<template>
  <YContainer>
    <z-breadcrumb
      :items="[
        { text: 'Página inicial', url: 'https://querobolsa.com.br/' },
        { text: 'Programas do Governo', url: 'https://querobolsa.com.br/programas-do-governo' },
        { text: pageName },
      ]"
    />

    <FinancialAidArticle :page="page" />
    <MontillaSlot slug="enem-page-bottom" />
  </YContainer>
</template>

<script>
import { YContainer } from '@quero/yeti'

import { retry } from '~/assets/js/utils/http'
import capitalizeSlug from '~/assets/js/utils/capitalize-slug'
import FinancialAidArticle from '~/components/financial-aid-article'
import MontillaSlot from '~/components/montilla-slot'
import hotjarMixin from '~/mixins/hotjar'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Home',

  components: {
    FinancialAidArticle,
    YContainer,
    MontillaSlot,
  },

  mixins: [
    hotjarMixin,
  ],

  async asyncData ({ params, $cms, error }) {
    const home = params.home

    if (!home) return error({ statusCode: 500, message: 'Failed to fetch content, page not defined.\n' })

    const pageName = capitalizeSlug(home)

    const URL = `/items/FinancialAidPages?filter[path][_eq]=/${home}`

    const request = await retry(
      () => $cms.$get(URL),
      { retries: 6 },
    ).catch((err) => {
      error({ statusCode: 500, message: 'Failed to fetch content.\n' + err.message })
    })

    if (!request?.data.length) return error({ statusCode: 500, message: `Failed to fetch content for page ${params.home}.\n` })
    return {
      pageName,
      page: Object.freeze(request?.data[0]),
    }
  },
  data () {
    return {
      pageName: '',
      page: {
        title: '',
        content: [],
        sidebar: [
          {
            links: [],
          },
        ],
      },
    }
  },
  head () {
    return {
      title: this.page.headTitle,
      meta: this.page.headMeta || [],
      link: this.page.headLink,
    }
  },
  mounted () {
    window.montilla.track('content_view', {
      content_view_name: 'home',
      hotjar_sample: this.hotjarSample,
    })
  },
}
</script>
